import React, { useEffect, useState } from "react";
import api from "../utils/api";

const Feedback = () => {
  const [ctx, setCtx] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [liked, setLiked] = useState(null); // true/false/null
  const [message, setMessage] = useState("");
  const [honeypot, setHoneypot] = useState(""); // bot trap

  const [status, setStatus] = useState({ loading: false, ok: false, error: "" });
  const [token, setToken] = useState("");

  useEffect(() => {
    const raw = sessionStorage.getItem("ccg_feedback_context");
    if (raw) {
      try {
        setCtx(JSON.parse(raw));
      } catch {
        setCtx(null);
      }
    }
    const storedToken = sessionStorage.getItem("ccg_feedback_token");
    if (storedToken) setToken(storedToken);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, ok: false, error: "" });

    try {
      const res = await api.post("/api/feedback", {
        token: token || null,
        name: name.trim() || null,
        email: email.trim() || null,
        liked,
        message: message.trim(),
        honeypot, // must be empty
        page_path: ctx?.from_path || null,
        page_url: ctx?.from_url || null,
        page_title: ctx?.from_title || null,
        client_ts: ctx?.ts || null,
      });

      setStatus({ loading: false, ok: true, error: "" });
      setMessage("");
      setName("");
      setEmail("");
      setLiked(null);
      sessionStorage.removeItem("ccg_feedback_context");
      sessionStorage.removeItem("ccg_feedback_token");
      setToken("");
    } catch (err) {
      const apiError =
        err?.response?.data?.error ||
        err?.message ||
        "Failed to submit feedback";
      setStatus({ loading: false, ok: false, error: apiError });
    }
  };

  return (
    <div style={{ maxWidth: 780, margin: "0 auto", padding: "28px 14px" }}>
      <h1 style={{ marginBottom: 6 }}>Quick feedback</h1>
      <p style={{ marginTop: 0, color: "#555" }}>
        Tell us what’s missing, confusing, or inaccurate — we’ll use it to improve the tool.
      </p>

      {ctx?.from_path && (
        <div style={{ background: "#f7f7f7", padding: 12, borderRadius: 10, marginBottom: 14 }}>
          <div style={{ fontSize: 13, color: "#333" }}>
            <b>Page:</b> {ctx.from_path}
          </div>
          <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
            {ctx.from_title}
          </div>
        </div>
      )}

      <form onSubmit={submit} style={{ background: "#fff", padding: 16, borderRadius: 12, border: "1px solid #eee" }}>
        {/* Honeypot: keep hidden */}
        <input
          type="text"
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
          style={{ display: "none" }}
          tabIndex={-1}
          autoComplete="off"
        />

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>
            <label style={label}>Name (optional)</label>
            <input style={input} value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label style={label}>Email (optional)</label>
            <input style={input} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
        </div>

        <div style={{ marginTop: 12 }}>
          <label style={label}>Did this page help?</label>
          <div style={{ display: "flex", gap: 10 }}>
            <button type="button" onClick={() => setLiked(true)} style={pill(liked === true)}>
              👍 Yes
            </button>
            <button type="button" onClick={() => setLiked(false)} style={pill(liked === false)}>
              👎 Not really
            </button>
          </div>
        </div>

        <div style={{ marginTop: 12 }}>
          <label style={label}>What should we improve?</label>
          <textarea
            style={{ ...input, minHeight: 120 }}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            placeholder="Example: Add Uber Reserve info, train fare seems wrong, too many sections, etc."
          />
        </div>

        <div style={{ marginTop: 12, display: "flex", gap: 10, alignItems: "center" }}>
          <button
            type="submit"
            disabled={status.loading}
            style={{
              background: "#f4c400",
              border: "none",
              padding: "10px 14px",
              borderRadius: 10,
              fontWeight: 800,
              cursor: "pointer",
            }}
          >
            {status.loading ? "Sending..." : "Send feedback"}
          </button>

          {status.ok && <span style={{ color: "green" }}>Thanks — received!</span>}
          {status.error && <span style={{ color: "crimson" }}>{status.error}</span>}
        </div>

        <p style={{ fontSize: 12, color: "#666", marginTop: 12 }}>
          We’ll only use your email to follow up about this feedback. No marketing.
        </p>
      </form>
    </div>
  );
};

const label = { display: "block", fontSize: 13, fontWeight: 700, marginBottom: 6 };
const input = { width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd" };
const pill = (active) => ({
  border: "1px solid #ddd",
  background: active ? "#eef9f0" : "#fff",
  padding: "8px 12px",
  borderRadius: 999,
  cursor: "pointer",
  fontWeight: 700,
});

export default Feedback;
